import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js';
import { formatDate } from '../../utils/formatDate';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

function OffensesLineChart({ data }) {
  // Debug logging
  console.log('OffensesLineChart received data:', data);
  console.log('Data type:', typeof data);
  console.log('Is array:', Array.isArray(data));

  // Safety check for data
  if (!data || !Array.isArray(data)) {
    console.log('Data is not an array, showing loading message');
    return <div className="p-4 text-gray-500">Loading chart data...</div>;
  }

  if (data.length === 0) {
    console.log('Data array is empty');
    return <div className="p-4 text-gray-500">No data available</div>;
  }

  console.log('Rendering chart with', data.length, 'data points');

  const chartData = {
    labels: data.map(d => formatDate(d.date)),
    datasets: [{
      label: 'Offenses per Day',
      data: data.map(d => d.count),
      borderColor: '#ca8a04',
      backgroundColor: 'rgba(202, 138, 4, 0.2)',
      fill: true,
      tension: 0.1,
    }],
  };
   
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
      },
    },
  };

  return <Line options={options} data={chartData} />;
}

export default OffensesLineChart;